var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"bg-main-img"}),_c('b-overlay',{attrs:{"show":_vm.isLoading,"rounded":"sm","spinner-variant":"warning"}},[_c('Header'),_c('b-container',[_c('b-row',[_c('b-col',[_c('router-view')],1)],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }